import { render } from "./DeniedLiquidations.vue?vue&type=template&id=742335ad"
import script from "./DeniedLiquidations.vue?vue&type=script&lang=js"
export * from "./DeniedLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__